<template>
  <v-card dark class="edit experience-organization" v-if="value">
    <v-card-title primary-title>
      <LogoUpload
        :src="value.logo"
        :path="`/admin/experience_organizations/${value.id}/logo`"
        @success="logoSuccess"
      />
      <div>
        <div class="headline">{{ experienceOrganization.name }}</div>
      </div>
    </v-card-title>

    <v-alert error transition="scale-transition" :value="value.errors">
      <ul>
        <li v-for="(message, i) in value.errors" :key="`error-${i}`">
          {{ message }}
        </li>
      </ul>
    </v-alert>

    <v-card-text>
      <v-form v-model="valid" @submit.prevent="submit" ref="form">
        <v-text-field label="Name" v-model="experienceOrganization.name" :rules="rules.name" />

        <v-autocomplete
          label="Industry"
          v-if="industries.length > 0"
          v-model="experienceOrganization.industry"
          :items="industries"
          :rules="rules.industry"
          required
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn flat @click="$emit('cancel')" color="grey">
        Cancel
      </v-btn>
      <v-btn :disabled="!valid" @click="submit" color="primary">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Components
import LogoUpload from '@/components/LogoUpload'

// Data
import industries from '@/data/industries'

// Vue Component
export default {
  components: { LogoUpload },

  props: { value: Object },

  data() {
    return {
      experienceOrganization: JSON.parse(JSON.stringify(this.value)),
      // Validations
      valid: true,
      rules: {
        name: [v => !!v || 'must be specified'],
        industry: [v => (!!v && industries.some(i => i === v)) || 'must be specified'],
      },
      // Data
      industries,
    }
  },

  methods: {
    logoSuccess() {
      this.$store.dispatch('snackbarSuccess', 'Logo uploaded')
      this.$store.dispatch('admin/experience_organizations/fetch', this.value.id)
    },

    submit() {
      if (this.$refs.form.validate()) this.$emit('update', this.experienceOrganization)
    },
  },
}
</script>
